import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HighlightOff } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import styled from "styled-components";
import { formatSkipDateDisplay } from "../../SWR/SkipDays/skipDaysQuery-utils";
var SD_Text;
(function (SD_Text) {
    SD_Text["MY_SKIPPED_DAYS"] = "My Skipped Day(s)";
    SD_Text["YOU_HAVE_NO_SKIP_DAYS"] = "You have no skip days";
})(SD_Text || (SD_Text = {}));
export const MySkippedDays = ({ skippedDays, allSkipDays, handleUpdate }) => {
    return (_jsxs(Stack, Object.assign({ gap: 1 }, { children: [_jsx(Typography, Object.assign({ color: "primary", variant: "body2" }, { children: SD_Text.MY_SKIPPED_DAYS })), _jsxs(Stack, Object.assign({ justifyContent: "flex-start", alignItems: "flex-start", gap: 0.5 }, { children: [skippedDays && skippedDays.length === 0 && _jsx(Typography, { children: SD_Text.YOU_HAVE_NO_SKIP_DAYS }), allSkipDays &&
                        allSkipDays.map((day) => {
                            if (day.skip) {
                                return (_jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "center", width: "100%" }, { children: [_jsx(Typography, { children: formatSkipDateDisplay(day.customerDate) }), _jsx(IconButton, Object.assign({ sx: { m: 0, p: 0 }, onClick: () => handleUpdate(day.customerDate, !day.skip), size: "medium" }, { children: _jsx(RemoveDayButton, { sx: { p: 0 } }) }))] }), day.customerDate));
                            }
                        })] }))] })));
};
//TODO-MUI: UPDATE ALL STYLES TO LEVERAGE THE MUI V5 THEME AND STYLING OPTIONS.
const RemoveDayButton = styled(HighlightOff) `
  &:hover {
    cursor: pointer;
  }
`;
